@let conversationTemplate = conversationType()?.conversationDataListItemTemplate;
@if (conversationTemplate) {
  <div
    [innerHTML]="
      conversationTemplate
        | handlebar
          : templateData()
          : $any(conversationType()?.conversationDataSchema)?.required
        | safeHtml
    "
    class="conversation-data"></div>
}
